import { css } from 'lit';
export default css ` 
         @charset "UTF-8";
/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
:root,
:host {
  --size-base-unit: 0.5rem;
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to right" or "to left" need to be switched to using deg values
 * 3) Background Position From is used for reversing animation from right to left at 0%
 * 4) Background Position To is used for reversing animation from right to left at 100%
 * 5) Rotate Icon to 180deg for nav button
 * 6) Transformation size for badge left positions
 * 7) Transformation size for badge right positions
 * 8 to 18) Padding values for Input Field Type Tel
 */
[dir=rtl] {
  --rtlTranslateX: 50%; /* 1 */
  --rtlGradientToRight: 270deg; /* 2 */
  --rtlBackgroundPositionFrom: -135%; /* 3 */
  --rtlBackgroundPositionTo: 0%; /* 4 */
  --rtlRotate180: 180deg; /* 5 */
  --rtlRotate135: 135deg;
  --rtlBadgeLeft: -1.5; /* 6 */
  --rtlBadgeRight: 1.5; /* 7 */
  --rtlTelTypeInputFieldPaddingStart: calc(var(--size-base-unit) * 5); /* 8 */
  --rtlTelTypeInputFieldPaddingEnd: calc(var(--size-base-unit) * 2); /* 9 */
  --rtlTelTypeInputFieldMedPaddingStart: calc(var(--size-base-unit) * 4.5); /* 10 */
  --rtlTelTypeInputFieldMedPaddingEnd: calc(var(--size-base-unit) * 1.5); /* 11 */
  --rtlTelTypeInputFieldSmPaddingStart: calc(var(--size-base-unit) * 4); /* 12 */
  --rtlTelTypeInputFieldSmPaddingEnd: calc(var(--size-base-unit) * 1); /* 13 */
  --rtlTelTypeInputFieldCharBeforePaddingEnd: calc(var(--size-base-unit) * 3.75); /* 14 */
  --rtlTelTypeInputFieldCharAfterPaddingStart: calc(var(--size-base-unit) * 6); /* 15 */
  --rtlTelTypeInputFieldCharAfterErrPaddingStart: calc(var(--size-base-unit) * 9); /* 16 */
  --rtlTelTypeInputFieldIconAfterErrPaddingStart: calc(var(--size-base-unit) * 8); /* 17 */
  --rtlTelTypeInputFieldIconCharAfterErrPaddingStart: calc(var(--size-base-unit) * 12); /* 18 */
  --rtlDisplayNone: none;
  --rtlDisplayBlock: block;
  --rtlDrawerRightTranslateX: -100%;
  --rtlDrawerLeftTranslateX: 100%;
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/**
 * style for text ellipsis
 */
/**
 * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
 */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */ /* ------------------------------------*\
 #TIME-SELECTOR-LIST
\*------------------------------------ */
/**
 * Container for a heading and list of times
 */
.cat-c-time-selector-list {
  max-width: max-content;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--cat-theme-color-background-default);
}
.cat-c-time-selector-list .cat-c-time-selector-list__top {
  width: calc(var(--size-base-unit) * 12.625);
}

/**
 * Inner container for list of times and set min height as per the figma to render time selector
 */
.cat-c-time-selector-list__inner {
  flex: 1 0 0;
  overflow: auto;
  min-height: calc(var(--size-base-unit) * 35.125);
  background-color: var(--cat-theme-color-background-default);
  /** 
   * Adjust scrollbar styles for consistent appearance across browsers
   */
  /**
   * Only show scrollbar when hovering over list for non-touch devices
   */
}
.cat-c-time-selector-list__inner::-webkit-scrollbar {
  background-color: transparent;
  width: calc(var(--size-base-unit) * 0.75);
}
@media not (hover: none) {
  .cat-c-time-selector-list__inner:hover::-webkit-scrollbar-thumb {
    border-radius: var(--cat-border-radius-md);
    background-color: var(--cat-theme-color-background-subtle-hover);
  }
}

/**
 * Horizontal list
 */
.cat-c-time-selector-list--horizontal .cat-c-time-selector-list__inner {
  display: flex;
  min-height: auto;
  padding-block-end: calc(var(--size-base-unit) * 0.275);
  padding-inline-start: calc(var(--size-base-unit) * 0);
  /** 
   * Adjust horizontal scrollbar dimensions
   */
}
.cat-c-time-selector-list--horizontal .cat-c-time-selector-list__inner::-webkit-scrollbar {
  width: auto;
  height: calc(var(--size-base-unit) * 0.75);
}

/**
 * Horizontal list
 */
.cat-c-time-selector-list--horizontal {
  flex-direction: row;
  max-width: none;
  height: auto;
}
.cat-c-time-selector-list--horizontal .cat-c-time-selector-list__top {
  width: calc(var(--size-base-unit) * 7);
}

/**
 * Heading appearing before list of times
 */
.cat-c-time-selector-list__top {
  margin-block-start: -1px;
  margin-inline-end: calc(var(--size-base-unit) * 0.6987);
  padding-block-start: calc(var(--size-base-unit) * 0.375);
  background: var(--cat-theme-color-background-default);
}
.cat-c-time-selector-list__top .cat-c-time-selector-list__heading {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  margin: 0;
  color: var(--cat-theme-color-content-strong);
  font-weight: var(--cat-font-weight-bold);
  text-align: center;
  padding: calc(var(--size-base-unit) * 1.25) calc(var(--size-base-unit) * 1.25) calc(var(--size-base-unit) * 1.125);
  box-shadow: var(--cat-theme-box-shadow-sm);
  border-block-end: var(--cat-border-width-sm) solid var(--cat-theme-color-border-default);
  word-break: break-word;
  hyphens: auto;
}
.cat-c-time-selector-list--horizontal .cat-c-time-selector-list__top .cat-c-time-selector-list__heading {
  padding-block-end: 0;
  padding: calc(var(--size-base-unit) * 1.75) calc(var(--size-base-unit) * 1);
  border-inline-end: var(--cat-border-width-sm) solid var(--cat-theme-color-border-default);
  border-block-end: 0;
}
.cat-c-time-selector-list--horizontal .cat-c-time-selector-list__top {
  padding-block-start: calc(var(--size-base-unit) * 0);
}

/** 
 * The actual list of times
 */
.cat-c-time-selector-list__list {
  list-style: none;
  padding: calc(var(--size-base-unit) * 3) calc(var(--size-base-unit) * 0.25) calc(var(--size-base-unit) * 0.125);
  margin: 0;
  display: grid;
  justify-content: center;
  gap: calc(var(--size-base-unit) * 0.5);
  background-color: var(--cat-theme-color-background-default);
}
.cat-c-time-selector-list--horizontal .cat-c-time-selector-list__list {
  display: flex;
  padding: 0;
  padding-block: calc(var(--size-base-unit) * 0.5);
  margin-inline-start: calc(var(--size-base-unit) * 0.5);
}

/**
 * Individual time button
 */
.cat-c-time-selector-list__button {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  color: var(--cat-theme-color-content-default);
  text-transform: uppercase;
  background: none;
  border: 0;
  border-radius: calc(var(--size-base-unit) * 25);
  padding: calc(var(--size-base-unit) * 1.25) calc(var(--size-base-unit) * 1);
  position: relative;
  cursor: pointer;
  white-space: nowrap;
  width: 100%;
  min-width: 5.5rem;
  transition: background-color var(--cat-anim-fade-quick) var(--cat-anim-ease), color var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
   * Hover/Focus styles
   */
  /**
   * Focus states for dates
   */
  /**
   * Selected
   */
  /**
   * Disabled
   */
}
.cat-c-time-selector-list__button:focus-visible, .cat-c-time-selector-list__button:hover {
  background-color: var(--cat-theme-color-background-subtle);
  cursor: pointer;
  outline: none;
}
.cat-c-time-selector-list__button:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, -2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-time-selector-list__button:focus {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, -2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  --cat-theme-offset-focus-ring: 0;
}
.cat-c-time-selector-list__button.is-active {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  color: var(--cat-theme-color-content-knockout);
  background-color: var(--cat-theme-color-background-xstrong);
}
.cat-c-time-selector-list__button:disabled, .cat-c-time-selector-list__button:disabled:focus, .cat-c-time-selector-list__button:disabled:hover {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
  background: none;
}
`;
